// src/lib/locale-path.ts
// Maps between the id (default, no prefix) and en (/en prefix) URL twins.
// Only "/" and the 3 legal pages have an EN twin today - blog is id-only
// (see EN_ROUTES). Extend EN_ROUTES when a route gets a real EN twin.
export type Locale = "id" | "en";

export const EN_ROUTES = [
  "/",
  "/legal/privacy-policy",
  "/legal/term-of-services",
  "/legal/cookies-policy",
  "/device-requirements",
];

export function isEnPath(pathname?: string | null): boolean {
  return !!pathname && (pathname === "/en" || pathname.startsWith("/en/"));
}

/** Strip the /en prefix, returning the canonical (id) path. */
export function toIdPath(pathname: string): string {
  if (pathname === "/en") return "/";
  if (pathname.startsWith("/en/")) return pathname.slice(3);
  return pathname;
}

export function currentLocale(pathname?: string | null): Locale {
  return isEnPath(pathname) ? "en" : "id";
}

export function hasEnTwin(pathname: string): boolean {
  return EN_ROUTES.includes(toIdPath(pathname));
}

/** Build the href for `idPath` (canonical, unprefixed) in the given locale.
 *  Falls back to the id path when there's no EN twin (e.g. blog). */
export function localeHref(idPath: string, locale: Locale): string {
  if (locale === "id") return idPath;
  if (!EN_ROUTES.includes(idPath)) return idPath;
  return idPath === "/" ? "/en" : `/en${idPath}`;
}
